document.addEventListener("DOMContentLoaded", function() {
  async function addToCart(productId, title) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: productId })
      });
      const data = await response.json();
      if (data && data.status && data.status !== 200) {
        console.error("Add to cart error:", data.description || data);
        return false;
      }
      handleAfterAddToCart(title);
      return true;
    } catch (error) {
      console.error("Add to cart request failed:", error);
      return false;
    }
  }

  function handleAfterAddToCart(title) {
    const mode = window.theme && theme.settings && theme.settings.afterAddToCart;
    if (mode === "notification") {
      const tpl = document.getElementById("AddedNotification");
      if (!tpl || !tpl.content) return;
      const notification = tpl.content.firstElementChild.cloneNode(true);
      notification.dataset.productTitle = title;
      const container = document.querySelector(".pageheader--sticky") || document.body;
      container.appendChild(notification);
    } else if (mode === "drawer") {
      const drawer = document.querySelector(".js-cart-drawer");
      if (drawer && typeof drawer.open === "function") drawer.open();
    }
  }

  function startLoader(btn) {
    if (!btn) return;
    btn.classList.add("plp-atc-load-start");
    btn.style.color = "transparent";
    btn.disabled = true;
  }

  function endLoader(btn) {
    if (!btn) return;
    btn.classList.remove("plp-atc-load-start");
    btn.classList.add("plp-atc-load-end");
    setTimeout(() => {
      btn.classList.remove("plp-atc-load-end");
      btn.style.removeProperty("color");
      btn.disabled = false;
    }, 1000);
  }

  function showVariantSelectorModal(variants, title, sourceBtn) {
    const modal = document.getElementById("variant-selector-modal");
    const variantOptions = document.getElementById("variant-options");
    const addToCartButton = document.getElementById("add-to-cart-button");
    const productTitle = document.getElementById("product-title");
    const messageContainer = document.getElementById("variant-message");

    if (!modal || !variantOptions || !addToCartButton || !productTitle) {
      endLoader(sourceBtn);
      return;
    }

    if (messageContainer) {
      messageContainer.textContent = "";
    }

    productTitle.textContent = title || "";
    variantOptions.innerHTML = "";

    variants.forEach((variant, index) => {
      const variantOption = createVariantOption(variant, index);
      variantOptions.appendChild(variantOption);
    });

    function closeModal() {
      modal.style.display = "none";
      if (modal._outsideClose) {
        window.removeEventListener("click", modal._outsideClose);
        modal._outsideClose = null;
      }
      endLoader(sourceBtn);
    }

    addToCartButton.onclick = (e) => handleAddToCartButtonClick(title, modal, e, sourceBtn);
    modal.style.display = "flex";

    const closeEl = document.querySelector(".plp-atc-close");
    if (closeEl) closeEl.onclick = closeModal;

    modal._outsideClose = function(event) {
      if (event.target === modal) closeModal();
    };
    window.addEventListener("click", modal._outsideClose);
  }

  function getVariantLabelText(variant) {
    if (typeof variant.option2 === "string" && variant.option2.trim()) {
      return variant.option2;
    }
    const parts = (variant.title || "").split("/").map(s => s.trim());
    if (parts.length > 1 && parts[1]) {
      return parts[1];
    }
    return variant.title || "Option";
  }

  function createVariantOption(variant, index) {
    const variantOption = document.createElement("div");
    const variantId = `variant-option-${index}`;
    const labelText = getVariantLabelText(variant);
    variantOption.innerHTML = `
      <label class="opt-label opt-label--btn btn relative text-center" for="${variantId}">
        <span class="js-value">${labelText}</span>
      </label>
      <input type="radio" class="opt-btn visually-hidden focus-label js-option" name="variant" id="${variantId}" value="${variant.id}" required>
    `;
    const input = variantOption.querySelector("input");
    input.addEventListener("change", function() {
      document.querySelectorAll(".opt-label").forEach(label => label.classList.remove("selected-variant"));
      variantOption.querySelector(".opt-label").classList.add("selected-variant");
      const msg = document.getElementById("variant-message");
      if (msg) msg.textContent = "";
    });
    return variantOption;
  }

  async function handleAddToCartButtonClick(title, modal, e, sourceBtn) {
    const el = e.target;
    const selectedVariant = document.querySelector('input[name="variant"]:checked');
    const messageContainer = document.getElementById("variant-message");
    const messageDiv = document.querySelector(".message");

    if (!selectedVariant) {
      if (!messageContainer) {
        if (messageDiv) {
          const m = document.createElement("div");
          m.id = "variant-message";
          m.style.color = "red";
          m.textContent = "Please select a size before adding to cart.";
          messageDiv.appendChild(m);
        }
      } else {
        messageContainer.textContent = "Please select a size before adding to cart.";
      }
      return;
    }

    if (messageContainer) {
      messageContainer.textContent = "";
    }

    el.classList.add("plp-atc-load-start");
    el.style.color = "transparent";

    const ok = await addToCart(selectedVariant.value, title);

    el.classList.remove("plp-atc-load-start");
    el.classList.add("plp-atc-load-end");
    setTimeout(() => {
      el.classList.remove("plp-atc-load-end");
      el.style.removeProperty("color");
      if (ok) {
        if (modal && modal._outsideClose) {
          window.removeEventListener("click", modal._outsideClose);
          modal._outsideClose = null;
        }
        if (modal) modal.style.display = "none";
        endLoader(sourceBtn);
      } else {
        const msg = document.getElementById("variant-message") || document.createElement("div");
        if (!msg.id) {
          msg.id = "variant-message";
          msg.style.color = "red";
          msg.textContent = "Could not add to cart. Please try again.";
          const host = document.querySelector(".message") || modal;
          if (host) host.appendChild(msg);
        } else {
          msg.style.color = "red";
          msg.textContent = "Could not add to cart. Please try again.";
        }
        endLoader(sourceBtn);
      }
    }, 1000);
  }

  document.addEventListener("click", async (e) => {
    const plpAtc = e.target.closest(".plp-atc");
    if (!plpAtc || plpAtc.classList.contains("event-attached")) return;

    plpAtc.classList.add("event-attached");
    const btn = plpAtc;
    startLoader(btn);

    const handle = plpAtc.getAttribute("data-product-handle");
    if (!handle) {
      endLoader(btn);
      setTimeout(() => plpAtc.classList.remove("event-attached"), 600);
      return;
    }

    try {
      const productData = await fetch(`/products/${handle}.json`).then(res => res.json());
      const variants = productData?.product?.variants || [];
      const title = productData?.product?.title || "";

      if (variants.length > 1) {
        showVariantSelectorModal(variants, title, btn);
      } else if (variants.length === 1) {
        const ok = await addToCart(variants[0].id, title);
        endLoader(btn);
        if (!ok) {
          console.error("Single-variant add to cart failed");
        }
      } else {
        console.error("No variants found for product:", handle);
        endLoader(btn);
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
      endLoader(btn);
    } finally {
      setTimeout(() => {
        plpAtc.classList.remove("event-attached");
      }, 600);
    }
  });
});